enum Bytes {
  fiveMB = 5242880,
}

export default Bytes;
